import { useEffect, useState } from "react";
import Resizer from "react-image-file-resizer";
import $ from "jquery";
import { InputBase, styled } from "@mui/material";
import * as exifr from 'exifr';

export const ROLE = {
  ALL   : {code : "ALL" , desc : "Login required"},
  SA    : {code : "SA"  , desc : "SA"},
  WA    : {code : "WA"  , desc : "WA"},
  MA    : {code : "MA"  , desc : "MA"},
  MO    : {code : "MO"  , desc : "MO"}
};

export const fileAccepts = [
    {code : "M", title : "동영상", extension : ".mp4"},
    {code : "I", title : "사진", extension : ".jpg,.jpeg,.png,.gif"},
    {code : "P", title : "PDF", extension : ".pdf"},
    {code : "E", title : "ETC", extension : ".hwp,.hwpx,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.zip"},
];

export const importantYns = [
  {code: "Y", title:"주요관리"},
  {code: "N", title:"유지보수"}
];

export const useTitle = () => {
  const [title, setTitle] = useState("");
  const updateTitle = () => {
    if (title) {
      const htmlTitle = document.querySelector("title");
      htmlTitle.innerHTML = title;
    }
  };
  useEffect(updateTitle, [title]);

  return setTitle;
}

export const getBrowserTitle = (hostname) => {
  const titleMap = {
    'bk.safewalks.kr': '백운 스마트 예지보전 플랫폼',
    'cmms.safewalks.kr': '스마트 예지보전 플랫폼',
  };

  const title = titleMap[hostname] || '스마트 예지보전 플랫폼';
  // console.log(title)
  return title;
}

export function replaceString(value, replaceStr='_') {
  if (value) {
    let modValue = value.replaceAll(' ',replaceStr);
    return modValue;
  }
  return "";
}

export function extensionCheck(fileName, acceptCode) {
  const extension = fileName.substring(fileName.lastIndexOf("."));
  const accept = fileAccepts.filter(item => item.code === acceptCode);
  const accepts = (accept[0].extension.toLowerCase()).split(",");
  return (accepts[0] === '' || accepts.includes(extension));
}


export function getExtension(fileName) {
  const extension = fileName.substring(fileName.lastIndexOf(".")).trim();
  // console.log(extension)
  return extension.toLowerCase();
}

export const getDiagnosisGradeColor = (grade) => {
  if (grade) {
    if (grade === 'A') {
      return "circle1";
    } else if (grade === 'B') {
      return "circle2";
    } else if (grade === 'C') {
      return "circle3";
    } else if (grade === 'D') {
      return "circle4";
    }
  }
  return "";
}

// export const equipmentFaultGrade = [
//   {
//     code: "EG_AB",
//     title: "A/B",
//     items:["O7_N","O9_G"],
//     color : "#2d83b4"
//   },
//   {
//     code: "EG_CD",
//     title: "C/D",
//     items:["O1_F","O5_D"],
//     color : "#2d83b4"
//     // color : "#e6202e"
//   }
//   // {
//   //   code: "EG_AB",
//   //   title: "A/B",
//   //   items:["O7_N","O9_G"],
//   //   color : "#2d83b4"
//   // },
//   // {
//   //   code: "EG_CD",
//   //   title: "C/D",
//   //   items:["O1_F","O5_D"],
//   //   color : "#2d83b4"
//   //   // color : "#e6202e"
//   // }
// ];

export function getTemperatureColor(temp) {
  if (temp) {
    if (temp >= 45) {
      return "font_red"
    } else if (temp > 40 && temp < 45) {
      return "font_orange"
    } else if (temp <= 40) {
      return "font_green"
    }
  }
  return "font_green";
}

// export const equipmentFaultStatusColors = [
//     {
//       code : "O1_F",
//       title : "bad",
//       color : "#2d83b4"
//       // color : "#e6202e"
//     },
//     {
//       code : "O2_M",
//       title : "error",
//       color : "#f16634"
//       // color : "#ef710b"
//     },
//     {
//       code : "O5_D",
//       title : "insuff",
//       color : "#2d83b4"
//       // color : "#e7c748"
//     },
//     {
//       code : "O6_C",
//       title : "communi",
//       color : "#f0f0f0"
//       // color : "#b2b2b2"
//     },
//     {
//       code : "O7_N",
//       title : "normal",
//       color : "#2d83b4"
//       // color : "#2666ae"
//     },
//     {
//       code : "O9_G",
//       title : "fine",
//       color : "#2d83b4"
//       // color : "#308a2a"
//     },
// ];

export const equipmentFaultStatusColors = [
  {
    code : "O1_N",
    color : "#2d83b4"
  },
  {
    code : "O2_I",
    color : "#e5a846"
  },
  {
    code : "O3_A",
    color : "#ed1c24"
  },
  {
    code : "O4_C",
    color : "#bbbbbb"
  }
];

export function orderString(list, property) {
  if (list && list.length > 0) {
    list.sort(function(a,b) {
      let upperCaseA = "";
      let upperCaseB = "";
      if (property) {
        upperCaseA = a[property].toUpperCase();
        upperCaseB = b[property].toUpperCase();
      } else {
        upperCaseA = a.toUpperCase();
        upperCaseB = b.toUpperCase();
      }
      if (upperCaseA > upperCaseB) return 1;
      if (upperCaseA < upperCaseB) return -1;
      if (upperCaseA === upperCaseB) return 0;
    });
  }
}

export function reverseOrderString(list, property) {
  if (list && list.length > 0) {
    list.sort(function(a,b) {
      let upperCaseA = "";
      let upperCaseB = "";
      if (property) {
        upperCaseA = a[property].toUpperCase();
        upperCaseB = b[property].toUpperCase();
      } else {
        upperCaseA = a.toUpperCase();
        upperCaseB = b.toUpperCase();
      }
      if (upperCaseA > upperCaseB) return -1;
      if (upperCaseA < upperCaseB) return 1;
      if (upperCaseA === upperCaseB) return 0;
    });
  }
}

export function orderNumber(list, property) {
  if (list && list.length > 0) {
    list.sort(function(a,b) {
      let upperCaseA = "";
      let upperCaseB = "";
      if (property) {
        upperCaseA = a[property];
        upperCaseB = b[property];
      } else {
        upperCaseA = a;
        upperCaseB = b;
      }
      if (upperCaseA > upperCaseB) return 1;
      if (upperCaseA < upperCaseB) return -1;
      if (upperCaseA === upperCaseB) return 0;
    });
  }
}

export function reverseOrderNumber(list, property) {
  if (list && list.length > 0) {
    list.sort(function(a,b) {
      let upperCaseA = "";
      let upperCaseB = "";
      if (property) {
        upperCaseA = a[property];
        upperCaseB = b[property];
      } else {
        upperCaseA = a;
        upperCaseB = b;
      }
      if (upperCaseA > upperCaseB) return -1;
      if (upperCaseA < upperCaseB) return 1;
      if (upperCaseA === upperCaseB) return 0;
    });
  }
}

export function numberComma(number) {
  if (number)
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  return null;
}


export function afileListFunc() {
  const $tableDiv = $("#tableDiv");
  const $fileDiv = $tableDiv.find("div.fileListDiv");
  let $fileElement = [];
  for(var i=0;i<$fileDiv.length;i++){
    $fileElement[i] = $("#"+$fileDiv[i].id);
    $fileElement[i].css('display','none');
    $fileElement[i].css('zIndex',0);
  }
  let $aTag = [];
  const $fileATag = $tableDiv.find("a.file_ATag");
  for(var k=0;k<$fileATag.length;k++){
    $aTag[k] = $("#"+$fileATag[k].id);

    $aTag[k].mouseover(function() {
      let aTagId = this.id;
      let divNum = aTagId.replaceAll("fileATag", '');
      let $divElement = $("#fileList"+divNum);
      for(var j=0;j<$fileElement.length;j++){
        $fileElement[j].css('display','none');
        $fileElement[j].css('zIndex',0);
      }

      try {
        $divElement.css('display','block');
        $divElement.css('zIndex',1);
      }catch(Exception) {}
    });

    $aTag[k].focus(function(){
      let aTagId = this.id;
      let divNum = aTagId.replaceAll("fileATag", '');
      let $divElement = $("#fileList"+divNum);

      for(var l=0;l<$fileElement.length;l++){
        $fileElement[l].css('display','none');
        $fileElement[l].css('zIndex',0);
      }

      try {
        $divElement.css('display','block');
        $divElement.css('zIndex',1);
      }catch(Exception) {}
    });
  }
}

export const BootstrapInput = styled(InputBase)(({ theme }) => ({
  'label + &': {
    marginTop: theme.spacing(3),
  },
  '& .MuiInputBase-input': {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    border: '1px solid #ced4da',
    fontSize: 16,
    padding: '8px 26px 8px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:focus': {
      borderRadius: 4,
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
}));

export const periodSearchSelectItems = [
  {
    code : 0,
    title : "올해"
  },
  {
    code : 1,
    title : "올해(1분기)"
  },
  {
    code : 2,
    title : "올해(2분기)"
  },
  {
    code : 3,
    title : "올해(3분기)"
  },
  {
    code : 4,
    title : "올해(4분기)"
  },
  {
    code : 5,
    title : "지난해"
  },
  {
    code : 6,
    title : "지난해(1분기)"
  },
  {
    code : 7,
    title : "지난해(2분기)"
  },
  {
    code : 8,
    title : "지난해(3분기)"
  },
  {
    code : 9,
    title : "지난해(4분기)"
  },
];

export const getTimeString = (time) => {
  if (time) {
    let timeTempD = parseInt(time / 24);
    if (timeTempD >= 1) {
      let timeTempM = parseInt(timeTempD / 30);
      if (timeTempM >= 1) {
        return [timeTempM].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')+"개월";
      } else {
        return timeTempD+"일";
      }
    } else {
      return time+"시간";
    }
  }
  return "-";
}

export function getGradeAxial(data, addStr='') {
	if (data) {
		// if (data["axial"+addStr] === 'X') {
		// 	return data["gradeX"+addStr];
		// } else if (data["axial"+addStr] === 'Y') {
		// 	return data["gradeY"+addStr];
		// } else if (data["axial"+addStr] === 'Z') {
		// 	return data["gradeZ"+addStr];
		// }
    return data["gradeX"+addStr];
	}
	return '-';
}

export function getGradeRadial(data, addStr='') {
	if (data) {
		// if (data["radial"+addStr] === 'X') {
		// 	return data["gradeX"+addStr];
		// } else if (data["radial"+addStr] === 'Y') {
		// 	return data["gradeY"+addStr];
		// } else if (data["radial"+addStr] === 'Z') {
		// 	return data["gradeZ"+addStr];
		// }
    return data["gradeY"+addStr];
	}
	return '-';
}

export function getGradeVertical(data, addStr='') {
	if (data) {
		// if (data["vertical"+addStr] === 'X') {
		// 	return data["gradeX"+addStr];
		// } else if (data["vertical"+addStr] === 'Y') {
		// 	return data["gradeY"+addStr];
		// } else if (data["vertical"+addStr] === 'Z') {
		// 	return data["gradeZ"+addStr];
		// }
    return data["gradeZ"+addStr];
	}
	return '-';
}


export function getOverallAxial(data, addStr='') {
	if (data) {
		// if (data["axial"+addStr] === 'X') {
		// 	return data["overallShaft"+addStr];
		// } else if (data["axial"+addStr] === 'Y') {
		// 	return data["overallHorizon"+addStr];
		// } else if (data["axial"+addStr] === 'Z') {
		// 	return data["overallVertical"+addStr];
		// }
    return data["overallShaft"+addStr];
	}
	return 0;
}

export function getOverallRadial(data, addStr='') {
	if (data) {
		// if (data["radial"+addStr] === 'X') {
		// 	return data["overallShaft"+addStr];
		// } else if (data["radial"+addStr] === 'Y') {
		// 	return data["overallHorizon"+addStr];
		// } else if (data["radial"+addStr] === 'Z') {
		// 	return data["overallVertical"+addStr];
		// }
    return data["overallHorizon"+addStr];
	}
	return 0;
}

export function getOverallVertical(data, addStr='') {
	if (data) {
		// if (data["vertical"+addStr] === 'X') {
		// 	return data["overallShaft"+addStr];
		// } else if (data["vertical"+addStr] === 'Y') {
		// 	return data["overallHorizon"+addStr];
		// } else if (data["vertical"+addStr] === 'Z') {
		// 	return data["overallVertical"+addStr];
		// }
    return data["overallVertical"+addStr];
	}
	return 0;
}

/**
 * 진동량 상태판정기준
 * @param {*} score 
 * @returns 
 */
export function getVibrationRatingStatusByScore(grade) {
  if (grade) {
    if (grade === 'A') {
      return "양호"
    } else if (grade === 'B') {
      return "보통"
    } else if (grade === 'C') {
      return "미흡"
    } else if (grade === 'D') {
      return "불량"
    }
  }
  return null;
}

/**
 * 신율 상태판정기준
 * @param {*} score 
 * @returns 
 */
export function getVBeltElongStatusByScore(score) {
  if (score || score === 0) {
    if (score < 1.5) {
      return "양호"
    } else if (score >= 1.5 && score < 2.0) {
      return "보통"
    } else if (score >= 2.0 && score < 2.5) {
      return "미흡"
    } else if (score >= 2.5 && score < 4.0) {
      return "불량"
    }
  }
  return null;
}

/**
 * 신율 상태판정기준
 * @param {*} score 
 * @returns 
 */
export function getVBeltElongStatusGradeByScore(score) {
  if (score || score === 0) {
    if (score < 1.5) {
      return "A"
    } else if (score >= 1.5 && score < 2.0) {
      return "B"
    } else if (score >= 2.0 && score < 2.5) {
      return "C"
    } else if (score >= 2.5 && score < 4.0) {
      return "D"
    }
  }
  return null;
}

/**
 * v-belt 길이 상태판정기준
 * @param {*} score 
 * @returns 
 */
export function getVBeltLengthStatusByScore(score) {
  if (score || score === 0) {
    if (score > 90) {
      return "양호"
    } else if (score >= 85 && score < 90) {
      return "보통"
    } else if (score >= 80 && score < 85) {
      return "미흡"
    } else if (score < 80) {
      return "불량"
    }
  }
  return null;
}


/**
 * v-belt 길이 상태판정기준
 * @param {*} score 
 * @returns 
 */
export function getVBeltLengthStatusGradeByScore(score) {
  if (score || score === 0) {
    if (score > 90) {
      return "A"
    } else if (score >= 85 && score < 90) {
      return "B"
    } else if (score >= 80 && score < 85) {
      return "C"
    } else if (score < 80) {
      return "D"
    }
  }
  return null;
}

/**
 * 동력전달율 상태판정기준
 * @param {*} score 
 * @returns 
 */
export function getVBeltEfficiencyStatusByScore(score) {
  if (score || score === 0) {
    if (score > 90) {
      return "양호"
    } else if (score >= 85 && score < 90) {
      return "보통"
    } else if (score >= 80 && score < 85) {
      return "미흡"
    } else if (score < 80) {
      return "불량"
    }
  }
  return null;
}

/**
 * 동력전달율 상태판정기준
 * @param {*} score 
 * @returns 
 */
export function getVBeltEfficiencyStatusGradeByScore(score) {
  if (score || score === 0) {
    if (score > 90) {
      return "A"
    } else if (score >= 85 && score < 90) {
      return "B"
    } else if (score >= 80 && score < 85) {
      return "C"
    } else if (score < 80) {
      return "D"
    }
  }
  return null;
}

export function getColorClassNameByGrade(grade) {
  if (grade) {
    if (grade === 'A') {
      return " ble_font"
    } else if (grade === 'B') {
      return " gre_font"
    } else if (grade === 'C') {
      return " yel_font"
    } else if (grade === 'D') {
      return " ju_font"
    }
    return ""
  }
}

export function getEquipmentCtgrImageNameByCodeOfDashboard(code) {
  if (code) {
    // if (code === 'ES') {
    //   return 'escalator.gif';
    // } else if (code === 'EV') {
    //   return 'elevator.gif';
    // } else if (code === 'AHU') {
    //   return 'fan_stop.gif';
    // } else if (code === 'PUMP') {
    //   return 'pump_stop.gif';
    // }
    if (code === 'HST') {
      return 'overhead_s.gif';
    }
  }
  return 'noimage.gif'
}

export function getEquipmentCtgrImageNameByCodeOfDashboardSub(code, opStatus, doorStatus=null, type='dashboard') {
  if (code) {
    // console.log(code, opStatus)
    if (code === 'HST') {
      if (opStatus) {
    // console.log(opStatus)
        if (opStatus === 'STOP')
          return 'overhead_s.gif';
        else if (opStatus === 'UP')
          return 'overhead_u.gif';
        else if (opStatus === 'DOWN')
          return 'overhead_d.gif';
        else if (opStatus === 'FORWARD')
          return 'overhead_f.gif';
        else if (opStatus === 'BACKWARD')
          return 'overhead_b.gif';
        else if (opStatus === 'LEFT')
          return 'overhead_l.gif';
        else if (opStatus === 'RIGHT')
          return 'overhead_r.gif';
        // else if (opStatus === 'ACTIVE')
        //   return 'overhead_u.gif';
        // else if (opStatus === 'ETC')
        //   return 'overhead_u.gif';
        else
          return 'overhead_u.gif';
      }
      return 'overhead_u.gif';
    }
  }
  return 'noimage.gif'
}

// export function getEquipmentISOGradeByStatus(status) {
//   if (status) {
//     if (status === 'O9_G') {
//       return "A"
//     } else if (status === 'O7_N') {
//       return "B"
//     } else if (status === 'O5_D') {
//       return "C"
//     } else if (status === 'O1_F') {
//       return "D"
//     }
//     return ""
//   }
// }

export const equipmentISOStatus = [
  {
    code: "A",
    title: "A",
    color : "font_blue"
  },
  {
    code: "B",
    title: "B",
    color : "font_green"
  },
  {
    code: "C",
    title: "C",
    color : "font_orange"
  },
  {
    code: "D",
    title: "D",
    color : "font_red"
  }
];

/**
 * 배터리 잔량 표현 이미지
 * @param {*} batLevel 
 * @returns 
 */
export function getBatLevelImgByBatLevel(batLevelData) {
  if (batLevelData === 0 || batLevelData) {
    let batLevel = batLevelData.toFixed(0);
    if (batLevel < 10) {
      return "bat_0-10.png"
    } else if (batLevel >= 10 && batLevel < 20) {
      return "bat_10-20.png"
    } else if (batLevel >= 20 && batLevel < 40) {
      return "bat_20-40.png"
    } else if (batLevel >= 40 && batLevel < 60) {
      return "bat_40-60.png"
    } else if (batLevel >= 60 && batLevel < 80) {
      return "bat_60-80.png"
    } else if (batLevel >= 80 && batLevel < 90) {
      return "bat_80-90.png"
    } else if (batLevel >= 90) {
      return "bat_90-100.png"
    }
  }
  return null;
}

export function fileChangedHandler(event, maxWith, maxHeight, responseUriFunc, alertMessage, setAlertMessage, handleAlertClick) {
  const file = event.target?.files?.[0];
  if (file) {
    try {
      if (!["image/jpeg", "image/png", "image/webp"].includes(file.type)) {
        // console.log("Unsupported file type:", file.type);
        alertMessage = "Unsupported file type: "+ file.type;
        setAlertMessage(alertMessage);
        handleAlertClick();
        responseUriFunc('')
        return;
      }

      Resizer.imageFileResizer(file, maxWith, maxHeight, "JPEG", 90, 0, responseUriFunc, "file", 0, 0)
    } catch (err) {
      console.log(err)
      alertMessage = err.message;
      setAlertMessage(alertMessage);
      handleAlertClick();
      responseUriFunc('')
    }
  }
}

export const isEquirectangular = (width, height) => {
  const ratio = width / height;
  return Math.abs(ratio - 2.0) < 0.05;
};

export const checkImageFromBlob = async (blob) => {
  // 1. URL 생성
  const url = URL.createObjectURL(blob);

  // 2. XMP 메타데이터 확인
  let meta = {};
  try {
    meta = await exifr.parse(blob, { xmp: true });
  } catch (e) {}

  const xmpCheck =
    meta?.UsePanoramaViewer === true ||
    meta?.GPano?.UsePanoramaViewer === true;

  // 3. 이미지 비율 확인
  const img = new Image();
  return new Promise((resolve) => {
    img.onload = () => {
      const ratioCheck = isEquirectangular(img.width, img.height);
      resolve({ url, is360: xmpCheck || ratioCheck });
    };
    img.src = url;
  });
};

export const checkVrFileByFileUrl = async(fileUrl) => {
  try {
    const response = await fetch(fileUrl); // 실제 API 주소로 변경
    const blob = await response.blob();
    const { url, is360 } = await checkImageFromBlob(blob);
    const result = {url : url, is360 : is360}
    return result;
  } catch (error) {
    console.error('이미지 다운로드 실패:', error);
  }
};
// export const resizeFile = (file, maxWidth, maxHeight) =>
//   new Promise((res) => {
//       Resizer.imageFileResizer(
//           file, // target file
//           maxWidth, // maxWidth
//           maxHeight, // maxHeight
//           "JPEG", // compressFormat : Can be either JPEG, PNG or WEBP.
//           90, // quality : 0 and 100. Used for the JPEG compression
//           0, // rotation
//           (uri) => res(uri), // responseUriFunc
//           "file" // outputType : Can be either base64, blob or file.(Default type is base64)
//           ,0,0	
//       );
//   }
// );